<modal-search-filter-item [title]="model.label" (save)="Save($event)" (close)="Close($event)" [processing]="processing" [modalMode]="modalMode">
  <div class="form-group row">
    <div *ngIf="model.helpText" class="col-md-12">
      <p class="border-bottom pb-3">{{model.helpText}}</p>
    </div>
    <div class="col-md-6">
      <div class="input-group mb-3">
        <div class="input-group-prepend">
          <span class="input-group-text">{{model.prefix}}</span>
        </div>
        <input class="font-reg form-control form-control-lg input-blue-border" #minValue name="minValue" type="number" min="0" [(ngModel)]="model.minValue" placeholder="Minimum" (keyup.enter)="Save($event)">
      </div>
    </div>
    <div class="col-md-6">
      <div class="input-group mb-3">
        <div class="input-group-prepend">
          <span class="input-group-text">{{model.prefix}}</span>
        </div>
        <input class="font-reg form-control form-control-lg input-blue-border" #maxValue name="maxValue" type="number" min="0" [(ngModel)]="model.maxValue" placeholder="Maximum" (keyup.enter)="Save($event)">
      </div>
    </div>
  </div>
</modal-search-filter-item>
